var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.children
    ? _c("div", { staticClass: "block docx-divider-block" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "divider-block__container j-drag-cls" }, [
      _c("div", { staticClass: "divider-block__content" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }